module.exports = __webpack_public_path__ + "765f8f90e4cbcd0e2bd0e5445413d127.obj";